// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__LG4Z+","left":"Virtual_left__ebBmd","wrapper":"Virtual_wrapper__6Cng3"};